import { ReactElement } from "react"

const FornyaIcon = (): ReactElement => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1748.26 1748.26"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="633.05"
        y1="410.59"
        x2="1064.05"
        y2="1566.59"
        gradientTransform="translate(0 2087.86) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#01c676" />
        <stop offset="1" stopColor="#03a865" />
      </linearGradient>
      <linearGradient
        id="linear-gradient1"
        x1="978.75"
        y1="931.19"
        x2="1614.75"
        y2="1619.19"
        gradientTransform="translate(0 2087.86) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#05995d" />
        <stop offset=".5" stopColor="#01c676" />
        <stop offset="1" stopColor="#03a865" />
      </linearGradient>
    </defs>
    <path
      style={{
        stroke: "url(#linear-gradient)",
        fill: "none",
        strokeWidth: "250px",
      }}
      d="M1394.81,448.98h-104c-331.37,0-600,268.62-600,599.99,0,396.68,0,816.85,0,659.01"
    />
    <path
      style={{
        stroke: "url(#linear-gradient1)",
        fill: "none",
        strokeWidth: "250px",
      }}
      d="M821.81,1122.98h104c331.37,0,600-268.63,600-600v-200"
    />
    <path
      style={{
        fill: "#01c676",
      }}
      d="M1213.81,1621.98h-180c-66.27,0-120-53.73-120-120v-180h180c66.27,0,120,53.73,120,120v180Z"
    />
  </svg>
)

export default FornyaIcon
